import React from "react";
import { TabType } from "shared/components/tabsMenuComponent/type";
import { useCopies } from "shared/hooks/useCopies";
import ViewProfileOverview from "./components/overview";
import ViewVendorProducts from "./components/products";
import ApiProductProfileView from "shared/types/ApiProductProfileView";
import { ApiFieldForProfileDisplay } from "shared/types/ApiFieldForProfileDisplay";
import ContextEntityType from "shared/enums/ContextEntityType";
import { OrganizationInfo } from "./types";
import OrganizationProfileOverview from "./components/organizationProfileOverview";

export default function useGetViewProfileTabs(props: {
  contextEntityType?: ContextEntityType;
  profile: Array<ApiFieldForProfileDisplay>;
  products?: Array<ApiProductProfileView>;
  organizationPlatformFields?: OrganizationInfo;
}) {
  const copies = useCopies();
  const hasOrgContext =
    props.contextEntityType === ContextEntityType.PROGRAM_ORGANIZATION ||
    props.contextEntityType === ContextEntityType.EVENT_ORGANIZATION;
  const tabsList: Array<TabType> = React.useMemo(() => {
    const arr = [
      {
        id: "overview",
        title: copies.get("vendor.profile.overview"),
        component: hasOrgContext ? (
          <OrganizationProfileOverview
            profile={props.profile}
            platformFieldsProfile={props.organizationPlatformFields}
          />
        ) : (
          <ViewProfileOverview profile={props.profile} />
        )
      }
    ];
    if (hasOrgContext && props.products?.length) {
      arr.push({
        id: "products",
        title: copies.get("vendor.profile.products"),
        component: <ViewVendorProducts products={props.products} />
      });
    }
    return arr;
  }, [copies, props.products, props.profile, hasOrgContext, props.organizationPlatformFields]);

  return { tabsList };
}
